import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {CreazionePraticaStoreService} from '../../services/creazione-pratica-store.service';
import {getComponentFromFormTenantLavoro, getFascicoloLavoro} from '../../config/lavoro-form-configuration';
import {
  getComponentFromFormTenantPareristica,
  getFascicoloPareristica
} from '../../config/pareristica-form-configuration';
import {
  getComponentFromFormTenantAministrativa,
  getFascicoloAmministrativo
} from '../../config/amministrativa-form-configuration';
import {
  getComponentFromFormTenantAutoritaInd,
  getFascicoloAutoritaInd
} from '../../config/autorita-indipendente-form-configuration';
import {getComponentFromFormTenantCivile, getFascicoloCivile} from '../../config/civile-form-configuration';
import {getComponentFromFormTenantPenale, getFascicoloPenale} from '../../config/penale-form-configuration';
import {getComponentFromFormTenantTributario, getFascicoloTriburario} from '../../config/tributario-form-configuration';
import {TipoFascicolo} from '../../../../../common/models/tipologiche/tipo-fascicolo';
import {PropertiesSettings} from '../../../../../core/configuration/properties-settings';
import {InsertionHostDirective} from '../../../../../common/directives/insertion-host.directive';
import {TipoPratica} from '../../../../../common/models/tipologiche/tipo-pratica';
import {OperationsService} from '../../../../../core/services/operations.service';
import {distinctUntilChanged, filter, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {TIPI_PRATICA} from '../../../../config/tipi-pratica.enum';


@Component({
  selector: 'app-step-dati-gen-fascicolo',
  templateUrl: './step-dati-gen-fascicolo.component.html',
  styleUrls: ['./step-dati-gen-fascicolo.component.css']
})
export class StepDatiGenFascicoloComponent implements OnInit, OnDestroy {

  @ViewChild(InsertionHostDirective) private form!: InsertionHostDirective;
  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>();
  formComponentDynamic: string;
  tipoPratica: TipoPratica;
  componentRef: ComponentRef<any>;
  tipoFascicolo: TipoFascicolo;
  fascicolo: any;

  private componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(private operationService: OperationsService,
    private factoryResolver: ComponentFactoryResolver,
    private creazionePraticaStore: CreazionePraticaStoreService) {
  }

  ngOnInit() {
    this.creazionePraticaStore.tipoPratica$
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(tipo => this.tipoPratica = tipo);
    this.creazionePraticaStore.tipoFascicolo$
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        takeUntil(this.componentDestroyed$)
        )
      .subscribe(tipo => {
        this.tipoFascicolo = tipo;
        if (this.tipoFascicolo) {
          this.getFormTenantByTipo();
        }
      });

    this.creazionePraticaStore.fascicolo$.pipe(takeUntil(this.componentDestroyed$)).subscribe(el => this.fascicolo = el);
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.removeDynamicComponent();
    this.form.viewContainerRef.clear();
  }

  private getFormTenantByTipo() {
    if(this.tipoPratica != null && this.tipoFascicolo != null)
      this.operationService
        .getFormTenantByTipo(this.tipoPratica.id, this.tipoFascicolo.id)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(response => {
          this.formComponentDynamic = response && response.idFormTenant ? response.idFormTenant : '';
          this.removeDynamicComponent();
          this.addDynamicComponent();
        });
  }

  private addDynamicComponent() {
    const factory = this.factoryResolver.resolveComponentFactory(this.getComponent(this.formComponentDynamic));

    const viewContainerRef = this.form.viewContainerRef;
    viewContainerRef.clear();
    this.componentRef = viewContainerRef.createComponent(factory);
    this.createFormField();
  }

  private removeDynamicComponent() {
    this.form.viewContainerRef.clear();
  }

  private createFormField() {
    const fascicolo = this.getFascicolo();
    fascicolo.tipoFascicolo = this.tipoFascicolo;
    this.creazionePraticaStore.setFascicolo(fascicolo);
    this.componentRef.instance.fascicolo = fascicolo;
    this.componentRef.instance.request = { fascicolo };
    this.componentRef.instance.nomeFascicolo = this.tipoFascicolo.label;
    this.componentRef.instance.labelCreatoDaSistema = PropertiesSettings.LABEL_CREATO_DA_SISTEMA;
    this.componentRef.instance.inserimento = true;
    this.componentRef.instance.wizard = true;
    this.componentRef.instance.minervaWizard = true;
    if (!!this.componentRef.instance.createForm) {
      this.componentRef.instance.createForm
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(() => {
          /*this.componentRef.instance.datiGeneraliForm.valueChanges.pipe(distinctUntilChanged()).subscribe(() =>
            {console.log(fascicolo);
            this.creazionePraticaStore.updateFascicolo(fascicolo);}
          );*/
          this.componentRef.instance.datiGeneraliForm.statusChanges.pipe(distinctUntilChanged()).subscribe(status => {
            //console.log('[status]', status)
            this.creazionePraticaStore.updateValidityFascicolo(status === 'VALID')
          })
        });
    }

    this.creazionePraticaStore.saveExitFascicoloEvent$.pipe(
      takeUntil(this.componentDestroyed$),
      filter(el => el === true),
      tap(() => this.creazionePraticaStore.updateFascicolo(fascicolo))
    ).subscribe();

    if (!!this.componentRef.instance.saveForm) {
      this.componentRef.instance.saveForm
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(() => {
          this.creazionePraticaStore.updateFascicolo(fascicolo);
          this.changeStep.emit();
        });
    }
    if (!!this.componentRef.instance.resetForm) {
      this.componentRef.instance.resetForm
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(() => {
          this.creazionePraticaStore.setTipoFascicolo(null);
          this.creazionePraticaStore.setFascicolo(null);
          this.removeDynamicComponent();
        });
    }
  }

  private getComponent(idForm): any {
    switch (this.tipoPratica.endpoint) {
      case TIPI_PRATICA.AMMINISTRATIVA : {
        return getComponentFromFormTenantAministrativa(idForm);
      }
      case TIPI_PRATICA.AUTORITA_IND_REG : {
        return getComponentFromFormTenantAutoritaInd(idForm);
      }
      case TIPI_PRATICA.CIVILE : {
        return getComponentFromFormTenantCivile(idForm);
      }
      case TIPI_PRATICA.LAVORO: {
        return getComponentFromFormTenantLavoro(idForm);
      }
      case TIPI_PRATICA.PARERISTICA: {
        return getComponentFromFormTenantPareristica(idForm);
      }
      case TIPI_PRATICA.PENALE: {
        return getComponentFromFormTenantPenale(idForm);
      }
      case TIPI_PRATICA.TRIBUTARIO : {
        return getComponentFromFormTenantTributario(idForm);
      }
    }
  }

  private getFascicolo(): any {
    if (this.fascicolo) {
      return this.fascicolo;
    }
    switch (this.tipoPratica.endpoint) {
      case TIPI_PRATICA.AMMINISTRATIVA : {
        return getFascicoloAmministrativo(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.AUTORITA_IND_REG : {
        return getFascicoloAutoritaInd(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.CIVILE : {
        return getFascicoloCivile(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.LAVORO: {
        return getFascicoloLavoro(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.PARERISTICA: {
        return getFascicoloPareristica(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.PENALE: {
        return getFascicoloPenale(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.TRIBUTARIO : {
        return getFascicoloTriburario(this.tipoFascicolo.endpoint);
      }
    }
  }

  setTipoFascicolo(tipoFascicolo: TipoFascicolo) {
    this.creazionePraticaStore.setTipoFascicolo(tipoFascicolo);
    //la chiamata a this.getFormTenantByTipo() non è necessaria in quanto, dopo
    //aver settato il tipo fascicolo nello store, lo stesso metodo viene chiamato in ngOnInit()
    //nella subscribe
    // this.getFormTenantByTipo();

  }


}
